import React, { Fragment } from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import ActionsBlock from './ActionsBlock';
import * as VatReturnListSelectors from '../../../../redux/reducers/vatReturn_list_reducer/selectors';
import { StateStatus } from '../../../../redux/utils/common';
import { useDispatch } from 'react-redux';
import VatReturnListActions from '../../../../redux/reducers/vatReturn_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles, Roles } from 'config';
import Filter from '../filter';

interface IProps {
  ROLE: Roles;
}

export default function DatatableList(props: IProps) {
  const result = VatReturnListSelectors.useGetVatReturnList();
  const ROLE = props.ROLE;

  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const period = query.get('period');
  const year = query.get('year');
  const declaration_status = query.get('declaration_status');
  const vat_return_state = query.get('vat_return_state');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(period && { period }),
    ...(year && { year }),
    ...(declaration_status && { declaration_status }),
    ...(vat_return_state && { vat_return_state }),
  };

  return (
    <Fragment>
      {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
        <Filter
          vat_num={vat_num}
          period={period}
          year={year}
          declaration_status={declaration_status}
          vat_return_state={vat_return_state}
        />
      )}
      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            VatReturnListActions.fetchVatReturnListAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </Fragment>
  );
}

export { ActionsBlock };
